import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faClose,
	faChevronDown,
	faLink,
} from '@fortawesome/free-solid-svg-icons'

import PopoverButton from '../PopoverButton/index.vue'
import { currencyFormat } from '@/helpers/currency-format'

library.add(faTrashAlt, faClose, faChevronDown, faLink)

@Component({
	components: {
		PopoverButton,
	},
})
export default class CServicosHospitalares extends Vue {
	@Prop({ default: '#aaa', type: String }) color!: string
	@Prop({ required: true, type: String }) id!: string
	@Prop({ required: true, type: Number }) infoId!: number

	form = {
		type: { irpj: 32, csll: 32 },
		months: 1,
		monthlyIncome: '30000000,00',
		deduction: 5000000,
	}

	advanced = {
		selic: 1.25,
	}

	money = {
		decimal: ',',
		thousands: '.',
		precision: 2,
		masked: false,
	}

	options = {
		type: [
			{ text: 'Serviços em Geral', value: { irpj: 32, csll: 32 } },
			{
				text: 'Transporte, exceto de cargas',
				value: { irpj: 16, csll: 12 },
			},
			{
				text: 'Comércio, Indústria e Serviços Hospitalares',
				value: { irpj: 8, csll: 12 },
			},
		],
	}

	get monthlySavingsIRPJ() {
		const monthlyIncomeInt = parseFloat(
			this.form.monthlyIncome.replaceAll('.', '').replaceAll(',', '.'),
		)

		const irpj =
			((monthlyIncomeInt - this.form.deduction) *
				(this.form.type.irpj / 100) *
				0.25 *
				0.1) /
			12

		const result = this.parse(irpj)

		return currencyFormat(result)
	}

	get monthlySavingsCSLL() {
		const monthlyIncomeInt = parseFloat(
			this.form.monthlyIncome.replaceAll('.', '').replaceAll(',', '.'),
		)

		const csll =
			((monthlyIncomeInt - this.form.deduction) *
				(this.form.type.csll / 100) *
				0.09 *
				0.1) /
			12

		const result = this.parse(csll)

		return currencyFormat(result)
	}

	get monthlySavings() {
		const monthlySavingsIRPJInt = parseFloat(
			this.monthlySavingsIRPJ.replaceAll('.', '').replaceAll(',', '.'),
		)
		const monthlySavingsCSLLInt = parseFloat(
			this.monthlySavingsCSLL.replaceAll('.', '').replaceAll(',', '.'),
		)

		const result = this.parse(monthlySavingsIRPJInt + monthlySavingsCSLLInt)

		this.$emit('savings', result)

		return currencyFormat(result)
	}

	get recuperateOn() {
		const monthlySavings = parseFloat(
			this.monthlySavings.replaceAll('.', '').replaceAll(',', '.'),
		)
		const result = this.parse(
			monthlySavings * this.form.months * this.advanced.selic,
		)
		this.$emit('recuperate', result)
		return currencyFormat(result)
	}

	get selectedType() {
		const option = this.options.type.find((option) => {
			return (
				JSON.stringify(this.form.type) === JSON.stringify(option.value)
			)
		})

		return option ? option.text : ''
	}

	get calcsEach() {
		return this.$store.state.calculators.calcsEach
	}

	get calcsPrint() {
		return this.$store.state.calculators.calcsPrint
	}

	parse(n) {
		if (isNaN(n)) return 0
		n = parseFloat(n)
		return parseFloat(n.toFixed(3))
	}

	save() {
		this.savePrint()
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			found.type = this.form.type
			found.months = this.form.months
			found.monthlyIncome = this.form.monthlyIncome
			found.selic = this.advanced.selic
		} else {
			this.calcsEach.unshift({
				id: this.id,
				type: this.form.type,
				months: this.form.months,
				monthlyIncome: this.form.monthlyIncome,
				selic: this.advanced.selic,
			})
		}
	}

	savePrint() {
		const found = this.calcsPrint.find((item) => this.id === item.id)

		const rows = () => {
			return [
				[
					{
						label: 'Faturamento Mensal',
						value: 'R$ ' + this.form.monthlyIncome,
					},
					{
						label: 'Coeficientes de Presunção',
						value: this.selectedType,
					},
				],
				[
					{
						label: 'Economia Mensal',
						value: 'R$ ' + this.monthlySavings,
					},
					{
						label: 'Recuperação em ' + this.form.months + ' meses',
						value: 'R$ ' + this.recuperateOn,
					},
				],
			]
		}

		if (found) {
			found.rows = rows()
			found.recuperate = this.recuperateOn
			found.savings = this.monthlySavings
		} else {
			this.calcsPrint.unshift({
				id: this.id,
				title: 'Lucro Presumido - Majoração do coeficiente de presunção',
				color: this.color,
				columns: 2,
				rows: rows(),
				type: 'table',
				recuperate: this.recuperateOn,
				savings: this.monthlySavings,
			})
		}
	}

	created() {
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			this.form.type = found.type
			this.form.months = found.months
			this.form.monthlyIncome = found.monthlyIncome
			this.advanced.selic = found.selic
		}
	}
}
